export function makeApiUrl(url, version = process.env.API_VER) {
	let lang = typeof global.lang == 'undefined' ? 'pl' : global.lang;
	return `${process.env.API_URL}/${lang}/${version}/${url}`;
}